import React from 'react';
import PropTypes from 'prop-types';

import {
  SR_BUTTON_THEME_ADOBE_GREY,
  SR_BUTTON_THEME_ADOBE_GREEN,
  SR_BUTTON_THEME_ADOBE_YELLOW,
} from 'client/components/SrButton/SrButton';

import SrSimpleMessageModal, {
  SR_SIMPLE_MESSAGE_MODAL_THEME_SLIDE_UP,
} from 'client/components/SrSimpleMessageModal/SrSimpleMessageModal';

const SrUtilitySetupNonContractPlansModal = ({
  selectedProvider,
  noContractPlanProviders,
  onSeeNoContractPlanOptions,
  onContinue,
  onClose,
}) => {
  const noContractProviderLabel =
    noContractPlanProviders.length === 1
      ? `${noContractPlanProviders[0].title} does not.`
      : 'others do not.';

  return (
    <SrSimpleMessageModal
      iconUrl="/images/warning-triangle-orange-large.svg"
      headline={`${selectedProvider.title} has contracts while ${noContractProviderLabel}`}
      underline
      maxWidth={400}
      theme={SR_SIMPLE_MESSAGE_MODAL_THEME_SLIDE_UP}
      srMultiButtons={[
        {
          buttonText: 'See no-contract options',
          onButtonClick: onSeeNoContractPlanOptions,
          buttonTheme: SR_BUTTON_THEME_ADOBE_GREEN,
        },
        {
          buttonText: 'I want a long-term contract',
          onButtonClick: onContinue,
          buttonTheme: SR_BUTTON_THEME_ADOBE_YELLOW,
        },
        {
          buttonText: 'Cancel',
          onButtonClick: onClose,
          buttonTheme: SR_BUTTON_THEME_ADOBE_GREY,
        },
      ]}
    />
  );
};

SrUtilitySetupNonContractPlansModal.propTypes = {
  selectedProvider: PropTypes.object.isRequired,
  noContractPlanProviders: PropTypes.array.isRequired,
  onClose: PropTypes.func.isRequired,
};

SrUtilitySetupNonContractPlansModal.displayName = 'SrUtilitySetupNonContractPlansModal';

export default SrUtilitySetupNonContractPlansModal;
